// extracted by mini-css-extract-plugin
module.exports = {"root":"BarChart_root__2lT7f","text-small":"BarChart_text-small__1ebfH"};